import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { apiFetch } from "./api/client";
import { UI } from "./designSystem";
import { getEffectiveRoles } from "./roleSimulator";
import AdminCriancas from "./AdminCriancas";
import AdminCriancasConsulta from "./AdminCriancasConsulta";

// Voltar dessas telas de administração deve ir pro painel de admin (/admin),
// não pro site.
const ADMIN_PATH = "/admin";

// Ponto de entrada UNICO pra "Kids e Teens" -- mesmo padrao de
// AdminMembrosPortal.jsx (ver comentario la pro raciocinio completo):
// decide sozinho, pelo papel de quem esta logado, entre o cadastro
// completo (ADMIN/SECRETARIA, AdminCriancas.jsx, /children) e a consulta
// reduzida-LGPD (SECRETARIA_CONSULTA, AdminCriancasConsulta.jsx,
// /children/directory -- sem contato de responsavel, sem saude/alergia,
// sem anotacoes). Os dois componentes de destino continuam intocados por
// dentro.
export default function AdminCriancasPortal() {
  const [mode, setMode] = useState("checking"); // checking | full | consulta | forbidden

  useEffect(() => {
    let alive = true;
    apiFetch("/auth/me", { method: "GET", skipSessionExpiredHandler: true })
      .then((me) => {
        if (!alive) return;
        if (me.passwordMustChange) {
          setMode("forbidden");
          return;
        }
        const effectiveRoles = getEffectiveRoles(me);
        if (effectiveRoles.includes("ADMIN") || effectiveRoles.includes("SECRETARIA")) {
          setMode("full");
        } else if (effectiveRoles.includes("SECRETARIA_CONSULTA")) {
          setMode("consulta");
        } else {
          setMode("forbidden");
        }
      })
      .catch(() => {
        if (alive) setMode("forbidden");
      });
    return () => {
      alive = false;
    };
  }, []);

  if (mode === "checking") {
    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          boxSizing: "border-box",
          backgroundColor: UI.shell,
          color: UI.text,
          fontFamily: "'DM Sans', system-ui, sans-serif",
          padding: "28px 20px 60px"
        }}
      >
        <div style={{ maxWidth: 480, margin: "18vh auto 0", textAlign: "center" }}>
          <p style={{ margin: 0, color: "#c7ced9", fontSize: 14, lineHeight: 1.6 }}>Carregando...</p>
        </div>
      </div>
    );
  }

  if (mode === "forbidden") {
    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          boxSizing: "border-box",
          backgroundColor: UI.shell,
          color: UI.text,
          fontFamily: "'DM Sans', system-ui, sans-serif",
          padding: "28px 20px 60px"
        }}
      >
        <div style={{ maxWidth: 480, margin: "18vh auto 0", textAlign: "center" }}>
          <p style={{ margin: 0, color: "#c7ced9", fontSize: 14, lineHeight: 1.6 }}>
            Esta página é restrita à secretaria (inclusive papel de consulta) e administradores.
          </p>
          <Link
            to={ADMIN_PATH}
            style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "#9fb0cc", fontSize: 13, fontWeight: 700, textDecoration: "none", marginTop: 18, justifyContent: "center" }}
          >
            <ArrowLeft size={14} /> Voltar
          </Link>
        </div>
      </div>
    );
  }

  if (mode === "consulta") {
    return <AdminCriancasConsulta portalAccess />;
  }

  return <AdminCriancas portalAccess />;
}
